module.exports = __webpack_public_path__ + "img/kuangjiao_yj_chenyihui.59bc3275.jpg";